module.exports = "https://static.energy5.com/_next/static/images/effortless3-ee4a06a46f6b8390cbbabffdc1362453.png";